<div class="input-wrap">
    <input disabled [value]="link" />
</div>
<div class="addon" mat-ripple (click)="copyTextToClipboard(link)">
    {{ "Copy to clippboard" | translate }}
</div>
